import IconButtonM from "@common/components/button/IconButtonM"
import TextM from "@common/components/text/TextM"
import React from "react"
import { Image, Pressable, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { checkIsPdf } from "../components/pdf/pdfHelpers"
import { theme } from "../theme/theme"

const FileElement = (props) => {
    const {
        uri,
        height,
        width,
        name,
        isSelecting,
        selected,
        parentHeight,
        onLongPress,
        onPress,
        longPressDisabled = true,
        onDelete,
        resendComponent,
        showResend = false,
    } = props

    const isPdf = checkIsPdf(uri)

    return (
        <View
            style={{
                alignItems: "center",
                height: parentHeight,
                width: isPdf ? 200 : (parentHeight * width) / height,
                marginRight: 5,
            }}
        >
            <Pressable
                onLongPress={onLongPress}
                onPress={onPress}
                style={{
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: selected ? 0.5 : 1,
                }}
            >
                {isPdf ? (
                    <View
                        style={{
                            backgroundColor: theme.colors.whiteAlmost,
                            borderRadius: 8,
                            padding: 20,
                            width: "90%",
                            height: "80%",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <FontAwesome5
                            name="file-pdf"
                            size={50}
                            color={theme.colors.primary}
                            style={{ marginBottom: 15 }}
                        />
                        <TextM
                            color={theme.colors.primary}
                            fontWeight="SemiBold"
                            fontSize={14}
                            style={{ textAlign: "center" }}
                            numberOfLines={2}
                        >
                            {name || "Document PDF"}
                        </TextM>
                    </View>
                ) : (
                    <Image
                        source={{ uri: uri }}
                        resizeMode={"contain"}
                        style={{
                            width: "100%",
                            height: "100%",
                        }}
                    />
                )}
            </Pressable>

            {resendComponent && showResend && resendComponent()}

            <IconButtonM
                onPress={onDelete}
                icon={"trash"}
                size={16}
                style={{
                    height: 30,
                    width: 30,
                    backgroundColor: theme.colors.white,
                    borderRadius: 30,
                    position: "absolute",
                    top: 20,
                    right: 10,
                }}
                iconColor={theme.colors.grey}
            />

            {isSelecting && (
                <FontAwesome5
                    name={selected ? "check-circle" : "circle"}
                    solid={selected}
                    color={theme.colors.grey}
                    size={26}
                    style={{
                        position: "absolute",
                        top: 5,
                        right: 10,
                    }}
                />
            )}
        </View>
    )
}

export default FileElement
